import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

import {ReactComponent as CheckIcon} from '../assets/images/icons/check.svg'

InputField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
}

export default function InputField({input, meta, ...props}) {
  const isError = meta.error && meta.touched
  if (input.type === 'checkbox')
    return (
      <FormControlLabel
        control={
          <Checkbox
            {...input}
            checked={Boolean(input.value)}
            icon={<div className="Checkbox" />}
            checkedIcon={
              <div className="Checkbox">
                <CheckIcon className="CheckIcon FadeIn" />
              </div>
            }
            color="default"
          />
        }
        {...props}
      />
    )
  return (
    <Fragment>
      <TextField {...input} fullWidth margin="normal" error={isError} {...props} />
      {isError && meta.error !== 'required' && (
        <FormHelperText error className="FadeIn">
          {meta.error}
        </FormHelperText>
      )}
    </Fragment>
  )
}
